<template>
  <div id="app">
    <router-view></router-view>
    <div class="footer" v-if="showFooter">
      <div class="footer-line line-1px"></div>
      <div class="footer-notes">
        <div class="more-info">
          <a href=https://everjournal.life/terms-and-conditions-cn.html target=_blank>条款</a>
          <a href=https://everjournal.life/privacy-policy-cn.html target=_blank>隐私</a>
          <!-- <a href="https://a.app.qq.com/o/simple.jsp?pkgname=tech.xiangzi.life" target=_self>下载</a> -->
          <a @click="handleClickFooter('/feature')">下载</a>
          <a @click="handleClickFooter('/price')">会员</a>
          </div>
        <div class="legal">
          <div class="signature-info">made with <span class=text-heart>❤</span> by xiangzi tech.</div>
          <div class="icp-info">© 2022 巷子科技 <a href=https://beian.miit.gov.cn/ target=_blank>浙ICP备18015514号-2</a></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from '@/api';

export default {
  mounted () {
    this.getUserInfo();
  },
  computed: {
    showFooter () {
      return (this.$route.path.indexOf('/bio') < 0) && (this.$route.path.indexOf('/diary') < 0)
    },
    // showClearHeader () {
    //   return this.$route.path === '/feature' || this.$route.path === '/price'
    // }
  },
  watch: {
    $router (to, from) {
      // console.log(this.$route.path);
    }
  },
  methods: {
    async getUserInfo () {
      const uid = localStorage.getItem('$$uid');
      const token = localStorage.getItem('$$token');
      // 未登录状态
      if (!uid || !token) {
        // this.$router.replace('/login');
        return;
      }
      // 已登录状态，更新用户信息
      try {
        const { data } = await api.user.getUserInfo(`/users/${uid}/`, {
          Authorization: token
        });
        this.$store.commit('updateUserLoginInfo', Object.assign({}, data, {
          ticket: token
        }));
      } catch (e) {
        console.error(e)
        // this.$router.replace('/login');
      }
    },
    handleClickFooter (value) {
      if (this.path === value) {
        return;
      }
      this.$router.push(value);
    }
  }
}
</script>
<style lang="less" scoped>
#app {
  min-width: 1000px;
}
</style>
<style lang="less">
@import url('~@/assets/styles/common.less');
.footer {
  position: relative;
  background-color: #fff;
  // width: 100%;
  width: 920px;
  height: 80px;
  margin: 0 auto;
  bottom: 0;
  display: flex;
  justify-content: center;
  .footer-notes {
    width: 900px;
    // height: 80px;
    margin: 0;
    padding: 10px 0;
    text-align: center;
    color: #999;
    font-weight: 100;
    font-size: 12px;
    line-height: 1.5;
    letter-spacing: 1px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  .more-info {
    text-align: left;
    height: 30px;
    line-height: 30px;
    a {
      display: inline-block;
      color: #333;
      margin-left: 20px;
      cursor: pointer;
      &:first-child {
        margin-left: 0;
      }
    }
  }
  .legal {
    display: flex;
    justify-content: space-between;
  }
  .text-heart {
    color: #fc5204;
  }
  .signature-info {
    text-align: left;
    height: 30px;
    line-height: 30px;
  }
  .icp-info {
    text-align: right;
    height: 30px;
    line-height: 30px;
    a {
      color: #999;
    }
  }
  .footer-line {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 80px;
  }
  .line-1px {
    height: 1px;
    background: #ccc;
    -webkit-transform: scaleY(.5);
    -webkit-transform-origin: 0 0;
    overflow: hidden;
  }
}
</style>
